var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{class:['legend-dot', _vm.icon_style, { 'faded': !_vm.isVisible }],attrs:{"color":_vm.color,"fab":"","dark":"","depressed":true},on:{"click":_vm.toggleVisibility}}),_c('span',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }